<!--
Copyright (c) 2020 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details.
-->

<template>
    <span class="email-validation-message">
        <template v-if="maskedEmail">
            {{ messageBefore }}<strong>{{ maskedEmail }}</strong>{{ messageAfter }}
        </template>
        <template v-else>
            {{ $t('pages.selfservice.registration.emailValidation') }}
        </template>
    </span>
</template>

<script>
import { maskEmail } from '@/lib/emailUtils';

/**
 * @description Stage for handling email validation
 *
 **/
export default {
    name: 'Email-Validation',
    props: {
        registeredEmail: {
            type: String,
            default: ''
        }
    },
    computed: {
        maskedEmail () {
            return maskEmail(this.registeredEmail);
        },
        messageParts () {
            return this.$t('pages.selfservice.registration.emailValidationWithEmail').split('{maskedEmail}');
        },
        messageBefore () {
            const parts = this.messageParts;
            return parts[0] || '';
        },
        messageAfter () {
            const parts = this.messageParts;
            return parts.length > 1 ? parts[1] : '';
        }
    }
};
</script>

<style scoped>
.email-validation-message {
    font-weight: 400;
    font-size: 16px;
}
</style>
